import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import {
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import { LessonEnrolment } from '../../services/classes/types';
import {
  getLessonEnrolmentLessonCode,
} from '../../utils/common/classes';

import {
  ButtonBackground,
  StyledCard,
} from './index.styles';

interface LessonChipProps {
  lessonEnrolment: LessonEnrolment;
  selected?: boolean,
  onMark?: (complete?: boolean) => void,
  editable?: boolean,
}

const getHomeworkStateIcon = (complete?: boolean) => {
  if (complete === true) return <CheckIcon fontSize="small" />;
  if (complete === false) return <CloseIcon fontSize="small" />;
  return <HorizontalRuleIcon fontSize="small" />;
};

const LessonChip = ({
  lessonEnrolment,
  selected = false,
  onMark = () => {},
  editable = false,
}: LessonChipProps) => (
  <StyledCard>
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography
        variant="body2"
        fontWeight={selected ? 'bold' : 'normal'}
      >
        {getLessonEnrolmentLessonCode(lessonEnrolment)}
      </Typography>
      {editable ? (
        <Stack
          direction="row"
          justifyContent="space-between"
        >
          <IconButton
            size="small"
            onClick={() =>
              onMark(lessonEnrolment.homework.complete === true ? undefined : true)}
          >
            <ButtonBackground
              $complete={lessonEnrolment.homework.complete === true ? true : 'none'}
            >
              <CheckIcon fontSize="small" />
            </ButtonBackground>
          </IconButton>
          <IconButton
            size="small"
            onClick={() =>
              onMark(lessonEnrolment.homework.complete === false ? undefined : false)}
          >
            <ButtonBackground
              $complete={lessonEnrolment.homework.complete === false ? false : 'none'}
            >
              <CloseIcon fontSize="small" />
            </ButtonBackground>
          </IconButton>
        </Stack>
      )
        : (
          <IconButton
            size="small"
            disabled
          >
            <ButtonBackground
              $complete={lessonEnrolment.homework.complete}
            >
              {getHomeworkStateIcon(lessonEnrolment.homework.complete)}
            </ButtonBackground>
          </IconButton>
        )}
    </Stack>
  </StyledCard>
);
export default LessonChip;
